/** @jsxImportSource @emotion/react */
import React from "react";
import { jsx, css } from "@emotion/react";
import { useEffect, useState, forwardRef } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { loginState, configState } from "../lib/State";
import log from "../lib/log";
import pr from "../lib/pr";
import CenterSelect from "./CenterSelect";
import MemberSearch from "./MemberSearch";
import {
  Select,
  MenuItem,
  AppBar,
  Toolbar,
  Typography,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormLabel,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MobileDatePicker from "@mui/lab/MobileDatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { ko } from "date-fns/locale";
import moment from "moment";
import ProductSearch from "./ProductSearch";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// 등록하기 팝업
function ReservationAdd(props) {
  const { login, onClose, tcidParent } = props;
  const token = localStorage.getItem("token");
  const [centers, setCenters] = useState([]);
  const [tcid, setTcid] = useState(tcidParent);
  const [showMemberSearch, setShowMemberSearch] = useState(false);
  const [sName, setSname] = useState("");
  const [date, setDate] = useState(null);
  const [showProductSearch, setShowProductSearch] = useState(false);
  const [pName, setPname] = useState("");
  const [amount, setAmount] = useState(0);
  const [salePrice, setSalePrice] = useState(0);
  const [teacher, setTeacher] = useState([]);
  const [hours, setHours] = useState([
    { id: 0, name: "09:00" },
    { id: 1, name: "10:00" },
    { id: 2, name: "11:00" },
  ]);
  const [tid, setTid] = useState('');

  // 데이타폼
  const [data, setData] = useState({
    token: token,
    cid: login.cid,
    level: login.level,
    mcd: login.mcd,
    uid: "",
    hour: "",
    sdate:null,
    state: "예약",
  });

  const load_teacher_select = async () => {
    pr('load_teacher_select');
    let result = await axios.post(
      configState.api + "/gympass_admin/teacher_select",
      {
        token: token,
        cid: data.cid,
        mcd: login.mcd,
        level: login.level,
        tcid: tcid
      }
    );    

    if (result.data.success === 1) {
      setTeacher(result.data.rows);
    }
  };

  const load_reservation_hours = async () => {
    let result = await axios.post(
      configState.api + "/gympass_admin/reservation_hours",
      {
        token: token,
        cid: data.cid,
        mcd: login.mcd,
        level: login.level,
      }
    );
    if (result.data.success === 1) {
      setHours(result.data.rows);
    }
  };

  const onHandleData = (e) => {
    setData((state) => {
      return { ...state, [e.target.name]: e.target.value };
    });
  };

  const onSubmit = async () => {
    let result = await axios.post(
      configState.api + "/gympass_admin/reservation_add",
      {...data, tcid:tcid, tid:tid }
    );
    if (result.data.success !== 1) {
      Swal.fire(result.data.msg);
      return;
    } else {
      Swal.fire({ title: "등록되었습니다.", showCloseButton: true }).then(
        (result) => {
          onClose();          
        }
      );
    }
  };

  const onCidChange = (e) => {};

  const handleClose = () => {};

  // MemberSearch
  const onShowMemberSearchClick = () => {
    setShowMemberSearch(true);
  };

  const onHideMemberSearchClick = () => {
    setShowMemberSearch(false);
  };

  const onAfterMemberSearchClick = (params) => {
    const { id, name } = params;
    setSname(name);
    setData((state) => {
      return { ...state, uid: id };
    });
  };

  const onCalendarChange = (dt) => {
    let dt_format = moment(dt).format("YYYY-MM-DD");
    setDate(dt_format);
    setData((state) => {
      return { ...state, sdate: dt_format };
    });
  };

  // ProductSearch
  const onShowProductSearchClick = () => {
    setShowProductSearch(true);
  };

  const onHideProductSearchClick = () => {
    setShowProductSearch(false);
  };

  const onAfterProductSearchClick = (params) => {
    const { id, name, amount } = params;
    setPname(name);
    setAmount(amount);
    setSalePrice(amount);
    setData((state) => {
      return { ...state, amount: amount, p_id: id };
    });
  };

  const onAmountChange = (e) => {
    setAmount(e.target.value);
    setData((state) => {
      return { ...state, amount: e.target.value };
    });
  };

  useEffect(() => {
    if (tcid !== "") {
      load_teacher_select();
      load_reservation_hours();
    }
  }, [tcid]);

  return (
    <Box>
      
      {/* 사용자 찾기 */}
      <Dialog
        open={showMemberSearch}
        onClose={() => {}}
        fullWidth={true}
        maxWidth="lg"
      >
        <AppBar sx={{ position: "static" }}>
          <Toolbar>
            <Box sx={{ flexGrow: 1 }}>
              <Typography style={{ fontSize: 18 }}>회원찾기</Typography>
            </Box>
            <IconButton
              edge="start"
              color="inherit"
              onClick={onHideMemberSearchClick}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <MemberSearch
          tcidParent={tcid}
          login={login}
          onAfterMemberSearchClick={onAfterMemberSearchClick}
          onHideMemberSearchClick={onHideMemberSearchClick}
        />
      </Dialog>

      {/* 상품 찾기 */}
      <Dialog
        open={showProductSearch}
        onClose={() => {}}
        fullWidth={true}
        maxWidth="lg"
      >
        <AppBar sx={{ position: "static" }}>
          <Toolbar>
            <Box sx={{ flexGrow: 1 }}>
              <Typography style={{ fontSize: 18 }}>상품찾기</Typography>
            </Box>
            <IconButton
              edge="start"
              color="inherit"
              onClick={onHideProductSearchClick}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <ProductSearch
          login={login}
          onAfterProductSearchClick={onAfterProductSearchClick}
          onHideProductSearchClick={onHideProductSearchClick}
        />
      </Dialog>

      <Box
        css={css`
          padding: 20px 60px;
        `}
      >
        {/* 센터명 */}
        <CenterSelect                            
              login={login}
              tcidParent={tcid}
              setTcidParent={setTcid}
            />     

        {/* 강사명 */}
        <Box>
          <FormControl
            css={css`
              margin-top: 10px;
            `}
          >
            <InputLabel id="select-teacher-label">강사명</InputLabel>
            <Select
              name="tid"
              labelId="select-teacher-label"
              css={css`
                width: 260px;
              `}
              label="가맹점"
              size="small"
              value={tid}
              onChange={(e)=> { 
                setTid(e.target.value);
                load_teacher_select();
              }}
            >
              {teacher.map((item, index) => {
                return (
                  <MenuItem value={item.id} key={index}>
                    {item.name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Box>

        {/* 고객명 */}
        <Box
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            InputProps={{
              readOnly: true,
            }}
            name="name"
            label="고객명"
            size="small"
            sx={{
              width: "180px",
            }}
            autoComplete="off"
            value={sName}
          ></TextField>

          <Button
            variant="contained"
            sx={{ ml: 1 }}
            onClick={onShowMemberSearchClick}
          >
            조회
          </Button>
        </Box>

        {/* 수업일자 */}
        <Box
          css={css`
            margin-top: 10px;
          `}
        >
          <LocalizationProvider dateAdapter={AdapterDateFns} locale={ko}>
            <MobileDatePicker
              allowSameDateSelection={true}
              value={data.sdate}
              label="수업일자"
              renderInput={(params) => <TextField {...params} />}
              onChange={onCalendarChange}
              inputFormat={"yyyy.MM.dd"}
              autoComplete="off"
            />
          </LocalizationProvider>
        </Box>

        {/* 수업시간 */}
        <Box>
          <FormControl
            css={css`
              margin-top: 10px;
            `}
          >
            <InputLabel id="select-teacher-label">수업시간</InputLabel>
            <Select
              name="hour"
              labelId="select-teacher-label"
              id="select-teacher"
              css={css`
                width: 260px;
              `}
              label="가맹점"
              size="small"
              value={data.hour}
              onChange={onHandleData}
            >
              {hours.map((item, index) => {
                return (
                  <MenuItem value={item.name} key={index}>
                    {item.name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Box>

        {/* 상태 */}
        <FormControl
          fullWidth
          css={css`
            margin-top: 10px;
          `}
        >
          <FormLabel>상태</FormLabel>
          <RadioGroup
            name="state"
            row
            aria-labelledby="demo-radio-buttons-group-label"
            onChange={onHandleData}
            value={data.state}
          >
            <FormControlLabel value="예약" control={<Radio />} label="예약" />
            <FormControlLabel value="결석" control={<Radio />} label="결석" />
            <FormControlLabel value="취소" control={<Radio />} label="취소" />
          </RadioGroup>
        </FormControl>

        {/* 등록완료 */}
        <Box
          css={css`
            text-align: center;
            margin-top: 30px;
          `}
        >
          <Button variant="contained" onClick={onSubmit}>
            등록완료
          </Button>
          <Button
            variant="contained"
            color="warning"
            css={css`
              margin-left: 10px;
            `}
            onClick={onClose}
          >
            취소
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default ReservationAdd;
